import { Pipe, PipeTransform } from '@angular/core';
import { Waypoint } from '@model';
import { getLanguageValue } from '@utility';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({ name: 'waypointNameById' })
export class WaypointNameByIdPipe implements PipeTransform {
    constructor(private translocoService: TranslocoService) {}

    transform(waypoints: Waypoint[] = [], id: number | undefined): string {
        if (!id) {
            return '';
        }
        const waypoint = waypoints.find(wp => wp.id === id);
        if (!waypoint) {
            return '';
        }

        return (
            getLanguageValue(
                waypoint.pointNameHr,
                waypoint.pointNameEn,
                waypoint.pointNameIt,
                waypoint.pointNameSlo,
                waypoint.pointNameSr,
                waypoint.pointNameBs,
                this.translocoService.getActiveLang()
            ) ||
            ''
        );
    }
}
